import ServiceUsersIndex from 'Pages/ServiceUsers';
import ServiceUsersShow from 'Pages/ServiceUsers/show';

export default [
    { path: '/service-users', component: ServiceUsersIndex, guards: ['group:Staff,Service User Family'] },
    { path: '/service-users/show/:user', component: ServiceUsersShow, guards: ['group:Staff,Service User Family'] },
];
